// extracted by mini-css-extract-plugin
export default {"upcoming":"BroadcastBadge_upcoming__KUCa-","icon":"BroadcastBadge_icon__zTzF-","live":"BroadcastBadge_live__Z0Oxe"};